import { Form, FormSection } from "components/ResumeForm/Form";
import { Input } from "components/ResumeForm/Form/InputGroup";
import RichEditor from "./Form/QuillEditor";
import type { CreateHandleChangeArgsWithDescriptions } from "components/ResumeForm/types";
import { useAppDispatch, useAppSelector } from "lib/redux/hooks";
import { changeEducations, selectEducations } from "lib/redux/resumeSlice";
import type { ResumeEducation } from "lib/redux/types";
import RichEditorWithSuggestions from "./Form/RichEditorWithSuggestions";

export const EducationsForm = () => {
  const educations = useAppSelector(selectEducations);
  const dispatch = useAppDispatch();
  const showDelete = educations.length > 1;
  const form = "educations";

  return (
    <Form form={form} addButtonText="Add School">
      {educations.map((item, idx) => {
        const { school, degree, gpa, startDate, endDate, descriptions } = item;
        const handleEducationChange = (
            ...[
              field,
              value,
            ]: CreateHandleChangeArgsWithDescriptions<ResumeEducation>
          ) => {
            dispatch(changeEducations({ idx, field, value } as any));
          };

          const showMoveUp = idx !== 0;
          const showMoveDown = idx !== educations.length - 1;

          return (
            <FormSection
              key={item.id ?? idx}
              form="educations"
              idx={idx}
              showMoveUp={showMoveUp}
              showMoveDown={showMoveDown}
              showDelete={showDelete}
              deleteButtonTooltipText="Delete school"
            >
              <Input
                label="School"
                labelClassName="col-span-full"
                name="school"
                placeholder="IIT Delhi"
                value={school}
                onChange={handleEducationChange}
              />
              <Input
                label="Start Date"
                labelClassName="col-span-3"
                name="startDate"
                placeholder="June 2024"
                value={startDate}
                onChange={handleEducationChange}
              />
              <Input
                label="End Date"
                labelClassName="col-span-3"
                name="endDate"
                placeholder="June 2024"
                value={endDate}
                onChange={handleEducationChange}
              />
              <Input
                label="Degree & Major"
                labelClassName="col-span-4"
                name="degree"
                placeholder="Bachelor of Technology (IT)"
                value={degree}
                onChange={handleEducationChange}
              />
              <Input
                label="GPA / Percentage"
                labelClassName="col-span-2"
                name="gpa"
                placeholder="7.43"
                value={gpa}
                onChange={handleEducationChange}
              />
              <div className="relative col-span-full">
                {/* <RichEditor
                  name="descriptions"
                  value={descriptions}
                  onChange={handleEducationChange}
                  labelClassName="col-span-full"
                  placeholder="Free paragraph space to list out additional activities, courses, awards etc"
                /> */}
                <RichEditorWithSuggestions
                  name="descriptions"
                  value={descriptions}
                  onChange={handleEducationChange}
                  placeholder="Free paragraph space to list out additional activities, courses, awards etc"
                  section="educations"
                />
              </div>
            </FormSection>
          );
        }
      )}
    </Form>
  );
};
